import React, { useState } from 'react';
import { init, send } from 'emailjs-com';

function Contact() {
  const [name, setName] = useState(''); // 「ご氏名」の部分
  const [mail, setMail] = useState(''); // 「メールアドレス」の部分
  const [title, setTitle] = useState(''); // 「件名」の部分
  const [message, setMessage] = useState(''); // 「お問い合わせ内容」の部分

  const sendMail = () => {
    console.log('ok');
    const userID = process.env.REACT_APP_USER_ID;
    const emailjsServeiceID = process.env.REACT_APP_EMAILJSSERVICE_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;
    if (userID !== undefined && emailjsServeiceID !== undefined && templateID !== undefined) {
      init(userID);

      const template_param = {
        to_name: name,
        to_email: mail,
        title: title,
        message: message,
      };
      const mailMark = new RegExp(`@`, 'gim');
      if (mail.match(mailMark)) {
        console.log('okokok');
        send(emailjsServeiceID, templateID, template_param).then(() => {
          window.alert('お問い合わせを送信致しました。');

          setName('');
          setMail('');
          setMessage('');
          setTitle('');
        });
      } else {
        window.alert(
          'メールアドレスが入力できていないようです！「@」マーク以降も入力できているか、ご確認ください！'
        );
      }
    }
  };
  const handleClick = (e) => {
    e.preventDefault();
    sendMail();
  };

  const disableSend = name === '' || mail === '' || title === '' || message === '';

  return (
    <div className="bg-gradient-to-b from-purple-600 to-indigo-700 h-96 w-full">
      <div className="md:px-20 px-4 py-8">
        <div className="flex items-center justify-between">
          <div className="w-full flex items-center justify-center my-12">
            <div className="absolute top-40 bg-white shadow rounded py-12 lg:px-28 px-8">
              <p className="md:text-3xl text-xl font-bold leading-7 text-center text-gray-700">
                お問い合わせ
              </p>
              <div className="md:flex items-center mt-12">
                <div className="md:w-72 flex flex-col">
                  <label className="text-base font-semibold leading-none text-gray-800">Name</label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="text-base leading-none text-gray-900 p-3 focus:oultine-none focus:border-indigo-700 mt-4 bg-gray-100 border rounded border-gray-200 placeholder-gray-100"
                  />
                </div>
                <div className="md:w-72 flex flex-col md:ml-6 md:mt-0 mt-4">
                  <label className="text-base font-semibold leading-none text-gray-800">
                    Email Address
                  </label>
                  <input
                    value={mail}
                    onChange={(e) => setMail(e.target.value)}
                    className="text-base leading-none text-gray-900 p-3 focus:oultine-none focus:border-indigo-700 mt-4 bg-gray-100 border rounded border-gray-200 placeholder-gray-100"
                  />
                </div>
              </div>
              <div className="md:flex items-center mt-8">
                <div className="md:w-72 flex flex-col">
                  <label className="text-base font-semibold leading-none text-gray-800">件名</label>
                  <input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="text-base leading-none text-gray-900 p-3 focus:oultine-none focus:border-indigo-700 mt-4 bg-gray-100 border rounded border-gray-200 placeholder-gray-100 "
                  />
                </div>
              </div>
              <div>
                <div className="w-full flex flex-col mt-8">
                  <label className="text-base font-semibold leading-none text-gray-800">
                    Message
                  </label>
                  <textarea
                    className="h-36 text-base leading-none text-gray-900 p-3 focus:oultine-none focus:border-indigo-700 mt-4 bg-gray-100 border rounded border-gray-200 placeholder-gray-100 resize-none"
                    defaultValue={''}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
              </div>
              <p className="text-xs leading-3 text-gray-600 mt-4">
                By clicking submit you agree to our terms of service, privacy policy and how we use
                data as stated
              </p>
              <div className="flex items-center justify-center w-full">
                <button
                  onClick={handleClick}
                  disabled={disableSend}
                  className="mt-9 text-base font-semibold leading-none text-white py-4 px-10 bg-indigo-700 rounded hover:bg-indigo-600 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 focus:outline-none"
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
